<ion-label>
    <div class="label">{{ label }}</div>
    <div class="value">{{ value }}</div>
</ion-label>